import { createLogger } from 'redux-logger';
export default createLogger({
    predicate: (getState, action) => action.type !== 'ASYNC_START' && action.type !== 'ASYNC_END',
    collapsed: (getState, action, logEntry) => true
});;